import Numeral from 'numeral'
import 'numeral/locales/pt-br'

Numeral.locale('pt-br')

export const toCurrency = value => Numeral(parseFloat(value)).format("$ 0.00[,]00")
